import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { brand } from 'config';
import { useProfileStore } from '@/stores/useProfileStore';
import { useDashboardStore } from '@/stores/useDashboardStore';

const bcomLoyallist = {
  loyallist: {
    name: 'Loyallist',
    icon: 'loyallist-small',
  },
  tol: {
    name: 'Top of the List',
    icon: 'loyallist-small-black',
  },
  tolunlocked: {
    name: 'Top of the List Unlocked',
    icon: 'loyallist-key-small',
  },
};

const useLoyalty = () => {
  const profileStore = useProfileStore();
  const dashboardStore = useDashboardStore();
  const { rewardsSummary } = storeToRefs(dashboardStore);

  const firstName = computed(() => profileStore.profile?.firstName);
  const tierName = computed(() => rewardsSummary.value?.tierName);
  const currentPoints = computed(() => rewardsSummary.value?.currentPoints);
  const pointsThresholdForAward = computed(() => rewardsSummary.value?.pointsThresholdForAward);

  // TODO: Check if additional logic is needed to calculate tier expiry date similar to current MCOM PROD.
  const tierExpiryDate = computed(() => rewardsSummary.value?.tierExpiryDate);
  const bcomTierName = computed(() => bcomLoyallist[tierName.value]?.name || bcomLoyallist.loyallist.name);
  const loyaltyIcon = computed(() => {
    if (brand === 'mcom') {
      return 'star-rewards-red-large';
    }
    return bcomLoyallist[tierName.value]?.icon || bcomLoyallist.loyallist.icon;
  });
  const formattedTierName = computed(() => (brand === 'mcom' ? tierName.value : bcomTierName.value));
  const isBaseTier = computed(() => (brand === 'mcom' ? ['bronze', 'silver'].includes(tierName.value) : tierName.value === 'loyallist'));
  const pointsToNextAward = computed(() => rewardsSummary.value?.pointsToNextAward);
  const error = computed(() => rewardsSummary.value?.errors?.error?.[0]?.message);

  return {
    rewardsSummary,
    formattedTierName,
    firstName,
    currentPoints,
    pointsThresholdForAward,
    tierExpiryDate,
    loyaltyIcon,
    tierName,
    isBaseTier,
    pointsToNextAward,
    error,
  };
};

export default useLoyalty;
